import type CountryCode from '@alltrails/types/CountryCode';
import { get } from '../../utils/get';
import { post } from '../../utils/post';

type TokenResponse = {
  token: string | null;
};

type UserMetadata = {
  alltrailsUsername: string | null;
  alltrailsUserEmail: string | null;
  alltrailsUserFirstName: string | null;
  alltrailsUserLastName: string | null;
  alltrailsUserPlusStatus: string | null;
  alltrailsUserSignupPlatform: string | null;
  alltrailsUserEmailSubscriptionStatus: string | null;
  alltrailsUserPlusSubscriptionType: string | null;
  alltrailsUserPlusSubscriptionRenewalDate: string | null;
  alltrailsUserPlusSubscriptionPlatform: string | null;
  alltrailsUserLoggedInStatus: boolean | null;
  alltrailsUserPlusSubscriptionPurchaseDate: string | null;
  alltrailsUserPlusSubscriptionAutoRenewal: boolean | null;
  alltrailsUserCountryCode: CountryCode | null;
};

const createToken = () => post<TokenResponse>('/api/alltrails/ada/tokens', {});

const getUserMetadata = () => get<UserMetadata>('/api/alltrails/ada/user_metadata', {});

export { createToken, getUserMetadata };
export type { UserMetadata };
